module.exports = __webpack_public_path__ + "static/img/4areaB_12.cdb3f70.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_12.png
// module id = 1185
// module chunks = 1